var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _templateObject = _taggedTemplateLiteralLoose(['\n  .Select__control {\n    cursor: pointer;\n    border-radius: 0;\n    border: ', ';\n    background-color: ', ';\n  }\n  .Select__placeholder {\n    color: ', ';\n  }\n  .Select__indicators {\n    .Select__indicator-separator {\n      background-color: ', ';\n    }\n    svg {\n      fill: ', ';\n    }\n  }\n'], ['\n  .Select__control {\n    cursor: pointer;\n    border-radius: 0;\n    border: ', ';\n    background-color: ', ';\n  }\n  .Select__placeholder {\n    color: ', ';\n  }\n  .Select__indicators {\n    .Select__indicator-separator {\n      background-color: ', ';\n    }\n    svg {\n      fill: ', ';\n    }\n  }\n']);
function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Select from 'react-select';
import Theme from '../../Theme';
export var errorStyles = {
  border: function border(_ref) {
    var hasError = _ref.hasError;
    return hasError && '1px solid ' + Theme.colors.danger;
  },
  dangerLight: function dangerLight(_ref2) {
    var hasError = _ref2.hasError;
    return hasError && '' + Theme.colors.dangerLight;
  },
  danger: function danger(_ref3) {
    var hasError = _ref3.hasError;
    return hasError && '' + Theme.colors.danger;
  }
};
export var StyledSelect = styled(Select)(_templateObject, errorStyles.border, errorStyles.dangerLight, errorStyles.danger, errorStyles.danger, errorStyles.danger);
export var selectStyles = {
  placeholder: function placeholder(styles) {
    return _extends({}, styles, {
      fontSize: 15,
      color: Theme.colors.blueGrey
    });
  }
};
var SelectField = function SelectField(_ref4) {
  var options = _ref4.options,
    field = _ref4.field,
    form = _ref4.form,
    errors = _ref4.errors,
    touched = _ref4.touched,
    placeholder = _ref4.placeholder;
  var hasError = errors[field.name] && touched[field.name];
  return React.createElement(StyledSelect, {
    options: options,
    name: field.name,
    value: options ? options.find(function (option) {
      return option.value === field.value;
    }) : '',
    onChange: function onChange(option) {
      return form.setFieldValue(field.name, option.value);
    },
    onBlur: field.onBlur,
    classNamePrefix: 'Select',
    placeholder: placeholder || 'Please Select',
    hasError: hasError,
    styles: selectStyles
  });
};
SelectField.propTypes = process.env.NODE_ENV !== "production" ? {
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string
  })),
  field: PropTypes.shape({
    value: PropTypes.string,
    name: PropTypes.string
  }),
  errors: PropTypes.object,
  touched: PropTypes.object,
  placeholder: PropTypes.string
} : {};
export default SelectField;